import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorReportingService {
  constructor(private apiService: ApiService) {}

  reportError(errorMessage: string, stackTrace: string): void {
    const error = {
      message: errorMessage,
      stackTrace: stackTrace,
      applicationName: 'UI'
    };

    this.apiService.post('v1/error', error).then(
      () => {},
      err => console.error('Failed to report error:', err)
    );
  }
}
